import * as React from 'react';

export function PageTitle(props: { children: React.ReactNode }) {
  return (
    <h1 className="text-2xl lg:text-4xl font-semibold uppercase mb-2">
      {props.children}
    </h1>
  );
}
